import { useNavigate } from 'react-router-dom';
import './bookPage.css';
import arabicCover from '../../assets/arabcover.png';

function ArabicEditionSection() {
  const navigate = useNavigate();

  const handlePreview = () => {
    window.open('/BEFOREWEGETOLDER-ARABIC-PREVIEW.pdf', '_blank');
  };

  return (
    <section className="arabic-edition">
      <div className="arabic-edition-grid two-columns">

        <div className="arabic-edition-content">
          <h2 className="arabic-edition-title">
            Available in Arabic
          </h2>
          <p className="arabic-edition-text">
            <em>قبل أن نتقدم في العمر</em> — the Arabic edition of <em>Before We Get Older</em>.
            <br />
            For anyone who wants to grow in Arabic.
          </p>
          <p className="arabic-edition-note">
            Available as an eBook only.
          </p>
          <div className="arabic-edition-buttons">
            <button className="hero-btn nowrap" onClick={handlePreview}>
              Preview Arabic Edition
            </button>
            <button className="hero-btn secondary nowrap" onClick={() => navigate('/order/bwgo-ar')}>
              Order Arabic eBook
            </button>
          </div>
        </div>

        <div className="arabic-edition-cover">
          <img
            src={arabicCover}
            alt="Before We Get Older – Arabic Edition"
            className="book-cover-img large"
          />
        </div>

      </div>
    </section>
  );
}

export default ArabicEditionSection;